import React from "react";
import { useSelector } from "react-redux";

import CheckoutCard from "app/checkout/CheckoutCard";
import TrustpilotBlock from "./TrustpilotBlock";

/**
 * `contactDetails` is populated by the checkout form on the way in, and by the
 * profile fetch for a signed-in customer. An anonymous customer who reloads the
 * confirmation URL has neither, so the email sentence degrades to a version
 * that doesn't name an address rather than rendering "sent to undefined".
 *
 * Note the single wrapping div: `CheckoutCard` rules between its *direct*
 * children, which is what groups blocks on the checkout page. Here the whole
 * block is one child, so it draws no internal rules.
 */
const ThankYouBlock = ({ className, orderNumber }) => {
  const { contactDetails } = useSelector((s) => s.checkout);
  const email = contactDetails?.email;

  return (
    <CheckoutCard className={className}>
      <div>
        {/* h1 for the document outline; gkit-h2 is the size the design uses. */}
        <h1 className="gkit-h2 gkit-m-0">Thank you for your order!</h1>

        {orderNumber && (
          <p className="gkit-p-17 gkit-mobile-15 gkit-mt-3 gkit-mb-0">
            Your order #{orderNumber} has been placed
          </p>
        )}

        <p className="gkit-p-17 gkit-mobile-15 gkit-mt-2 gkit-mb-0">
          {email
            ? `We are processing your order and an email confirmation will be sent to ${email}.`
            : "We are processing your order and an email confirmation is on its way."}
        </p>
      </div>

      {/*
        A second direct child of the card, so it picks up the card's own
        divider rule rather than needing its own separator.
      */}
      <TrustpilotBlock />
    </CheckoutCard>
  );
};

export default ThankYouBlock;
